export function effectivePlan(user) {
  if (user?.betaAccess === true) return "plus";
  return user?.plan === "completo" || user?.plan === "plus" ? user.plan : "free";
}

export function workspaceAccess(user) {
  if (["PREVIEW", "ACTIVE", "ARCHIVED"].includes(user?.workspace_access)) {
    return user.workspace_access;
  }
  return effectivePlan(user) === "free" ? "PREVIEW" : "ACTIVE";
}

export function hasWorkspaceCapability(user, capability) {
  if (typeof user?.capabilities?.[capability] === "boolean") {
    return user.capabilities[capability];
  }
  const state = workspaceAccess(user);
  if (state === "ACTIVE") return true;
  if (state === "ARCHIVED") {
    return [
      "view_workspace", "view_project", "update_project", "view_all_steps",
      "view_step_details", "view_documents_page", "download_documents",
      "delete_documents", "export_project", "view_profile",
    ].includes(capability);
  }
  return ["view_workspace", "view_project", "view_step_details", "view_profile", "ai_chat"].includes(capability);
}

export function canAccessWorkspace(user) {
  return Boolean(user) && hasWorkspaceCapability(user, "view_workspace");
}

export function hasActiveAccess(user) {
  return workspaceAccess(user) === "ACTIVE";
}

export function hasAppAccess(user) {
  return canAccessWorkspace(user);
}

export function hasPlusAccess(user) {
  return hasActiveAccess(user);
}
